export enum Device {
  WEB = 1,
  MOBILE = 2,
  ANDROID = 3,
  IOS = 4,
}
